// mapLayout.js — layout "tidy" horizontal: x = profundidad, y por hoja, padres centrados.
export const NODE_W = 210;
export const NODE_H = 52;
export const COL = 274;
export const ROW = 58;

export function computeLayout(roots, isOpen) {
  const pos = {};
  const edges = [];
  let leaf = 0;

  function walk(node, depth, par) {
    const open = isOpen(node.id);
    const kids = open && node.children ? node.children : [];
    if (par) edges.push({ from: par.id, to: node.id });
    const hasKids = !!(node.children && node.children.length);
    if (kids.length) {
      const ys = kids.map((k) => walk(k, depth + 1, node));
      const y = (ys[0] + ys[ys.length - 1]) / 2;
      pos[node.id] = { x: depth * COL, y, node, depth, hasKids, open };
      return y;
    }
    const y = leaf * ROW;
    leaf += 1;
    pos[node.id] = { x: depth * COL, y, node, depth, hasKids, open };
    return y;
  }
  (roots || []).forEach((r) => walk(r, 0, null));
  return { pos, edges };
}

export default computeLayout;
